import { SubjectResponse, UserIndustry } from '@/@types/client-api';
import { TextLinkBlock } from '@/@types/content';
import { ClientAPI } from '@/redux/api';

export interface ISubjectsQuery {
  onlyBabyPool: boolean;
  excludeEmpty?: boolean;
}

const taxonomyEndpoints = ClientAPI.injectEndpoints({
  endpoints: builder => ({
    getTaxonomyCatalogChildren: builder.query<TextLinkBlock[], string>({
      query: params => ({
        url: `/taxonomy/catalog-children?id=${params}`,
        method: 'GET'
      })
    }),
    getTaxonomySubjects: builder.query<SubjectResponse[], ISubjectsQuery>({
      query: params => ({
        url: `/taxonomy/subjects?onlyBabyPool=${params.onlyBabyPool}&excludeEmpty=${params.excludeEmpty ?? 'false'}`,
        method: 'GET',
        credentials: 'omit'
      })
    }),
    getTaxonomyIndustries: builder.query<UserIndustry[], boolean>({
      query: params => ({
        url: `/taxonomy/industries?excludeEmpty=${params}`,
        method: 'GET',
        credentials: 'omit'
      })
    })
  })
});

export const {
  useGetTaxonomyCatalogChildrenQuery,
  useGetTaxonomySubjectsQuery,
  useGetTaxonomyIndustriesQuery
} = taxonomyEndpoints;

export default taxonomyEndpoints;
